import { render, staticRenderFns } from "./GroupSettings.vue?vue&type=template&id=29ce21c6&scoped=true&"
import script from "./GroupSettings.vue?vue&type=script&lang=js&"
export * from "./GroupSettings.vue?vue&type=script&lang=js&"
import style0 from "./GroupSettings.vue?vue&type=style&index=0&id=29ce21c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ce21c6",
  null
  
)

export default component.exports